/* eslint-disable max-len */
import React from 'react';

const CheckboxUnchecked = () => (
  <svg
    viewBox="0 0 24 24"
    height="24"
    width="24"
    focusable="false"
    aria-hidden="true"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H6z"></path>
  </svg>
);

export default CheckboxUnchecked;
